export default "__VITE_ASSET__DY7$KDE0__"